/* Layout values shared by more than one panel.
 *
 * CHAT_HEIGHT is here rather than in either component because both the Website
 * section drafter and the Social Generator's Refine with Brill are chat panes
 * with a Send button at the bottom, and the whole point of the value is that
 * Send stays on screen. Two copies would drift, and the drift would be invisible
 * until someone on a laptop couldn't find the button.
 *
 * A fixed height put Send below the fold: the pane sits under a panel title, a
 * description, a control bar and a back button. Sized against the viewport it
 * gives back whatever the chrome above it takes, stops shrinking at 320 (below
 * that the conversation is unreadable and scrolling to Send is the lesser evil)
 * and stops growing at 620 so a tall monitor doesn't get a chat pane the height
 * of a door.
 *
 * `vh`, not `dvh` — an unsupported unit invalidates the whole clamp, and this
 * value is load-bearing.
 */
export const CHAT_HEIGHT = "clamp(320px, calc(100vh - 360px), 620px)";

/* THE SAME VALUE FOR A PHONE, where 360px of chrome is not what sits above it.
 * Her report, 2026-09-22, with two screenshots: on the drafting screen at 375
 * the conversation had about four lines and the input was below the fold —
 * "that whole top section makes typing almost impossible".
 *
 * 360 was measured against a panel title, a description, a control bar and a
 * back button. A phone has none of those now (the chrome is one row), but it
 * DOES have the app's own header and the bottom nav, which the desktop layout
 * does not: roughly 75 above and 56 below, plus the one chrome row and the
 * page's own padding. So the pane gives back about 215px rather than 360, and
 * stops growing at 720 — a tall phone should spend the whole screen on the
 * conversation, because there is nothing beside it to line up with. */
export const CHAT_HEIGHT_PHONE = "clamp(320px, calc(100vh - 215px), 720px)";

/* THE DRAFTING SCREEN, ON A WIDE ONE. Her read, 2026-09-24, on a laptop: "the
 * chat window is TINY, all this gunk up top is really too much." The 360 in
 * CHAT_HEIGHT was a panel title, a description, a control bar and a back
 * button; while she drafts none of those render now at any width (the phone's
 * one row, applied everywhere), so what sits above the pane is that one row and
 * the page's own padding. And it stops growing much later than 620: the cap
 * was there so a tall monitor did not get "a chat pane the height of a door",
 * but with nothing beside it competing, a big screen spending its height on
 * the conversation is the point.
 *
 * Only the drafting screen uses this. CHAT_HEIGHT stays for the panes that
 * still sit under a full panel header (the Offer brainstorm, Social). */
export const CHAT_HEIGHT_DRAFTING = "clamp(360px, calc(100vh - 170px), 1100px)";
